module.exports = __webpack_public_path__ + "static/media/error-character.5c5f776a.svg";